// based on this OL: http://localhost:3000/campaigns/dashboard/order-lines/d00li7fmnukc73c4nb9g?org_id=copvrgqi23gvjvci6hp0
// used with testDetachedCreativeFlag in ReportModal.tsx
export const testCreativeStats = {
  results: [
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cv7kqi69rlps73bk83v0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cv31a1fpvivs73e1pq0g',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cunmr854elts73clkem0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cud7b335ft8s739ebvs0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cud3b3r5ft8s739ebvr0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cucjekqp2m5s739leikg',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cuc0abf1vnms73aipeo0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cu8hfu4tvh0s73db3dcg',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cte94k4j7pic73a9g300',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cte8v24j7pic73a9g2v0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 2100,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cskhukied3cc73fliur0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cskhufied3cc73fliuq0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'csfc14gkekac73bichcg',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cs97uk0kekac73bicdqg',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cs7b7e0kekac73bicc3g',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'cs41lugkekac73bibq60',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          // creativeId: 'crm8hqrnbfbs73aaftd0', // banner
          creativeId: 'cppi91mq7utc73fa60rg', // video
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'crm8a23nbfbs73aaftc0',
        },
      },
    },
    {
      results: [
        {
          start: '2024-12-19T05:00:00.000Z',
          end: '2025-09-03T03:59:59.999Z',
          clicks: 21,
          completions: 0,
          conversions: 0,
          imps: Math.floor(Math.random() * 10000),
          impsViewed: 23209,
          pcts_25: 0,
          pcts_50: 0,
          pcts_75: 0,
          postClickConvs: 0,
          postViewConvs: 0,
          starts: 0,
          viewMeasuredImps: 29886,
        },
      ],
      totals: {
        clicks: 21,
        completions: 0,
        conversions: 0,
        imps: Math.floor(Math.random() * 10000),
        impsViewed: 23209,
        pcts_25: 0,
        pcts_50: 0,
        pcts_75: 0,
        postClickConvs: 0,
        postViewConvs: 0,
        starts: 0,
        viewMeasuredImps: 29886,
      },
      details: {
        resultsCount: 1,
        ids: {
          orgId: 'copvrgqi23gvjvci6hp0',
          campaignId: '',
          orderLineId: 'd00li7fmnukc73c4nb9g',
          creativeId: 'crfm67kl390c73dkldp0',
        },
      },
    },
  ],
  totals: {
    clicks: 138,
    completions: 0,
    conversions: 0,
    imps: 179085,
    impsViewed: 109053,
    pcts_25: 0,
    pcts_50: 0,
    pcts_75: 0,
    postClickConvs: 0,
    postViewConvs: 0,
    starts: 0,
    viewMeasuredImps: 158885,
  },
  details: {
    timezone: 'UTC',
    hourCount: 6191,
    resultsCount: 19,
    levelOfDetail: ['creative_id'],
    ids: [
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cv7kqi69rlps73bk83v0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cv31a1fpvivs73e1pq0g',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cunmr854elts73clkem0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cud7b335ft8s739ebvs0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cud3b3r5ft8s739ebvr0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cucjekqp2m5s739leikg',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cuc0abf1vnms73aipeo0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cu8hfu4tvh0s73db3dcg',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cte94k4j7pic73a9g300',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cte8v24j7pic73a9g2v0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cskhukied3cc73fliur0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cskhufied3cc73fliuq0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'csfc14gkekac73bichcg',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cs97uk0kekac73bicdqg',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cs7b7e0kekac73bicc3g',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'cs41lugkekac73bibq60',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'crm8hqrnbfbs73aaftd0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'crm8a23nbfbs73aaftc0',
      },
      {
        orgId: 'copvrgqi23gvjvci6hp0',
        campaignId: '',
        orderLineId: 'd00li7fmnukc73c4nb9g',
        creativeId: 'crfm67kl390c73dkldp0',
      },
    ],
    start: '2024-12-19T05:00:00.000Z',
    end: '2025-09-03T03:59:59.999Z',
  },
}
